import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../cn.js';

/** A small label for status. It carries no interaction: a clickable badge is a button. */
export const badgeVariants = cva(
  [
    'inline-flex items-center gap-(--space-xs)',
    'rounded-(--radius-full) px-(--space-sm) py-px',
    'text-(length:--font-size-caption) font-medium whitespace-nowrap',
    'border',
  ],
  {
    variants: {
      tone: {
        neutral:
          'bg-(--color-surface-sunken) text-(--color-text-secondary) border-(--color-border)',
        accent: 'bg-(--color-accent-subtle) text-(--color-accent) border-transparent',
        success: 'bg-(--color-success-subtle) text-(--color-success) border-transparent',
        warning: 'bg-(--color-warning-subtle) text-(--color-warning) border-transparent',
        danger: 'bg-(--color-danger-subtle) text-(--color-danger) border-transparent',
      },
    },
    defaultVariants: { tone: 'neutral' },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, tone, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ tone }), className)} {...props} />;
}
